import { IconProps } from '@tajdid/tajdid-ui/icons';

function CheckCircle(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19}
      height={20}
      {...props}
      fill="none"
      viewBox="0 0 19 20"
    >
      <path
        stroke="currentcolor"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M13.667 2.781a8.333 8.333 0 104 5.552"
      ></path>
      <path
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6.167 10.416s1.25 0 2.917 2.917c0 0 4.632-7.639 8.75-9.166"
      ></path>
    </svg>
  );
}

export default CheckCircle;
